import type { GameProductShort } from '@patrianna/shared-patrianna-types/store/GameModule'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type { PlayedGamesState } from './types'

const initialState: PlayedGamesState = {
  games: null,
  loaded: false,
  layout: '',
}

export const playedGamesSlice = createSlice({
  name: 'playedGames',
  initialState,
  reducers: {
    clearPlayedGames: () => initialState,

    setPlayedGames: (state, action: PayloadAction<{ games: GameProductShort[] }>) => {
      state.games = action.payload.games
    },

    setLayout: (state, action: PayloadAction<string>) => {
      state.layout = action.payload
    },

    setLoaded: (state, action: PayloadAction<boolean>) => {
      state.loaded = action.payload
    },
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof playedGamesSlice.actions>>

export const { actions } = playedGamesSlice
